import { imagesUrl, imageScale, isBrowser } from './config'
export const breakpoints = [300, 444, 588, 684, 972]

export const isLocalhost = () => {
  return Boolean(
    isBrowser && (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    )
  )
}

const defaultImageType = '15'
export const defaultImage =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export function getImg (
  imgSlug,
  imageType = defaultImageType,
  breakpoint = 972
) {
  if (!isBrowser) {
    return defaultImage
  }

  return `${imagesUrl}/gametiles/${imgSlug}/${imageScale}/${imgSlug}-tile-${imageType}-${breakpoint}.${imageExtension}`
}

export function supportsWebp () {
  if (!isBrowser) {
    return false
  }

  if ((navigator.userAgent.indexOf('iPhone') !== -1 ||
    navigator.userAgent.indexOf('iPad') !== -1) &&
    navigator.userAgent.indexOf('Safari') !== -1 &&
    (navigator.userAgent.indexOf('Version/') !== -1 ||
      navigator.userAgent.indexOf('CriOS/') !== -1)) {
    const iosVersion = navigator.userAgent.split(' ').find(x => x.includes('_'))
    const majorVersion = iosVersion && Number(iosVersion.split('_')[0])
    if (majorVersion >= 14) {
      return true
    }
  }
  if (navigator.userAgent.includes('Mac') &&
    'ontouchend' in document &&
    navigator.userAgent.indexOf('Version/') !== -1) {
    const version = navigator.userAgent.split(' ').find(x => x.includes('Version/'))
    const iosVersion = version.replace('Version/', '')
    const majorVersion = iosVersion && Number(iosVersion.split('.')[0])
    if (majorVersion >= 14) {
      return true
    }
  }
  const elem = document.createElement('canvas')
  if (elem.getContext && elem.getContext('2d')) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  // very old browser like IE 8, canvas not supported
  return false
}

export const imageExtension = supportsWebp() ? 'webp' : 'jpg'

export function isGameInfoValid (str) {
  str = str.replace(/\n/gi, '')
  const regex = /[^<p/>br&nsp;h2]/
  const validation = str.match(regex)
    ? Boolean(str.match(regex)[0].trim())
    : false
  return validation
}

export const removeEmptyValues = (data) => {
  const result = { ...data }
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key]) && !data[key].length) {
      delete result[key]
    }
    if (typeof data[key] === 'string' && !data[key]) {
      delete result[key]
    }
  })
  return result
}

export const getDefaultMetaDescription = (text) => {
  let result = ''
  if (text) {
    result = text.replace(/(<([^>]+)>)/gi, '').replace(/\r?\n|\r/g, ' ')
  }
  return result
}

export const escapeHtml = (string) => {
  const entityDict = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  }
  return String(string).replace(/[&<>"'`=/]/g, function (s) {
    return entityDict[s]
  })
}
